/**
 * Consent abstraction layer.
 * 
 * Reads consent state from Consentmo GDPR.
*/

var AttributionConsent = (function () {
  'use strict';

  var ATTR_DEBUG = false;
  var STATUS_COOKIE = 'cookieconsent_status';
  var DISABLED_COOKIE = 'cookieconsent_preferences_disabled';

  function log() {
    if (ATTR_DEBUG) console.log.apply(console, arguments);
  }

  function getCookie(name) {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var c = cookies[i].trim();
      if (c.indexOf(name + '=') === 0) {
        try {
          return decodeURIComponent(c.split('=').slice(1).join('='));
        } catch (e) {
          return null;
        }
      }
    }
    return null;
  }

  function getDisabledCategories() {
    var disabled = getCookie(DISABLED_COOKIE);
    if (!disabled) return [];

    return disabled
      .split(',')
      .map(function (c) { return c.trim(); })
      .filter(Boolean);
  }

  function getConsentState() {
    log('[Attribution][Consent] Checking marketing consent');

    try {
      var status = getCookie(STATUS_COOKIE);
      var disabledCategories = getDisabledCategories();

      log('[Attribution][Consent] Status:', status);
      log('[Attribution][Consent] Disabled categories:', disabledCategories);

      if (!status) {
        log('[Attribution][Consent] Consent DENIED (status missing)');
        return 'denied';
      }

      if (getCookie(DISABLED_COOKIE) === null) {
        log('[Attribution][Consent] Marketing consent DENIED (preferences missing or unreadable)');
        return 'denied';
      }

      if (status === 'allow' || status === 'accept_all' || status === 'accept_selected') {
        if (disabledCategories.indexOf('marketing') !== -1) {
          log('[Attribution][Consent] Marketing consent DENIED (marketing disabled)');
          return 'denied';
        } else {
          log('[Attribution][Consent] Marketing consent GRANTED');
          return 'granted';
        }
      }

      log('[Attribution][Consent] Consent DENIED (other status)');
      return 'denied';

    } catch (e) {
      log('[Attribution][Consent] Error reading consent', e);
      return 'denied';
    }
  }

  function getBridgeState() {
    try {
      var values = {};
      var duplicate = false;
      document.cookie.split(';').forEach(function (part) {
        var pieces = part.trim().split('=');
        var name = pieces.shift();
        if (name !== STATUS_COOKIE && name !== DISABLED_COOKIE) return;
        if (Object.prototype.hasOwnProperty.call(values, name)) duplicate = true;
        values[name] = decodeURIComponent(pieces.join('='));
      });
      if (duplicate || !Object.prototype.hasOwnProperty.call(values, DISABLED_COOKIE)) {
        return 'consent_unavailable';
      }
      var status = values[STATUS_COOKIE];
      if (['allow', 'accept_all', 'accept_selected'].indexOf(status) === -1) {
        return 'consent_unavailable';
      }
      var disabled = values[DISABLED_COOKIE].split(',').map(function (value) {
        return value.trim();
      }).filter(Boolean);
      if (disabled.indexOf('marketing') !== -1) return 'marketing_denied';
      if (disabled.some(function (value) {
        return ['preferences', 'analytics'].indexOf(value) === -1;
      })) return 'consent_unavailable';
      return 'granted';
    } catch (_) {
      return 'consent_unavailable';
    }
  }

  function getConsentMetadata() {
    var stored = AttributionStorage.read() || {};
    var prevMeta = stored.consentMeta || {};

    var currentStatus = getConsentState();
    var currentDisabled = getDisabledCategories();

    if (!prevMeta.status) {
      return {
        status: currentStatus,
        timestamp: new Date().toISOString(),
        disabled_categories: currentDisabled
      };
    }

    var statusChanged = prevMeta.status !== currentStatus;
    var disabledChanged =
      JSON.stringify(prevMeta.disabled_categories || []) !==
      JSON.stringify(currentDisabled || []);

    if (!statusChanged && !disabledChanged) {
      return prevMeta;
    }

    return {
      status: currentStatus,
      timestamp: new Date().toISOString(),
      disabled_categories: currentDisabled
    };
  }

   function onConsentChange() {
     log('[Attribution][Consent] Consent change detected');

      if (window.LMJ_CONSENT_BRIDGE_ENABLED === true && window.AttributionConsentBridge) {
        AttributionConsentBridge.reconcile('cmp_change');
        if (window.AttributionCart?.attachToCart) {
          AttributionCart.attachToCart({ onlyIfHasItems: true });
        }
      }

      var stored = AttributionStorage.read();
      if (!stored) return;

      var nextMeta = getConsentMetadata();

      if (JSON.stringify(stored.consentMeta) !== JSON.stringify(nextMeta)) {
        stored.consentMeta = nextMeta;
        stored.updated_at = new Date().toISOString();
        AttributionStorage.storePayload(stored);

        if (window.AttributionCart?.attachToCart) {
          AttributionCart.attachToCart();
        }
      }
  }

  /**
   * Attach listeners
   */
  function initListeners() {
    if (window.cookieStore && window.cookieStore.addEventListener) {
      window.cookieStore.addEventListener('change', function (event) {
        var relevant = (event.changed || []).concat(event.deleted || []).some(function (c) {
          return c.name === STATUS_COOKIE || c.name === DISABLED_COOKIE;
        });

        if (relevant) {
          log('[Attribution][Consent] Cookie change detected');
          onConsentChange();
        }
      });
      return;
    }

    // Fallback polling (Safari)
    var lastSnapshot = null;
    setInterval(function () {
      var snapshot = getCookie(STATUS_COOKIE) + '|' + getCookie(DISABLED_COOKIE);
      if (snapshot !== lastSnapshot) {
        lastSnapshot = snapshot;
        log('[Attribution][Consent] Polling change detected');
        onConsentChange();
      }
    }, 500);
  }

  // Auto-init listeners
  initListeners();

  return {
    getConsentState: getConsentState,
    getBridgeState: getBridgeState,
    getConsentMetadata: getConsentMetadata,
    getDisabledCategories: getDisabledCategories,
  };

})();
